let Environment = {
  chinaTomi: "0x644239aB43Ef12E0319670A9c666aFcC554B4b34",
  busd: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  tomi: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
};
export default Environment;
